import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isPropValid from '@emotion/is-prop-valid';
import { AsyncButton, SaveStates, Tooltip } from '@infl-ts/ui-advocate-components';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useToggle } from '@infl-ts/util-hooks';
import { isMobileBrowser } from '@infl-ts/util-platform';
import { stripEmojis } from '@infl-ts/util-string-strip-emojis';
import { useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box, Link, styled, TextField, Typography, useMediaQuery } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import copyToClipboard from 'copy-to-clipboard';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { absurd, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useCallback, useContext, useEffect, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LinkCard from '../link-card';
import StageLayout from '../stage-layout';
import * as alerts from './alerts';
import FacebookScripts from './facebook-scripts';
import { useShareContent } from './mutations';
import ShareButton from './share-button';
import ShareModal from './share-modal';
import { connectUrl } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var providerTitle = function providerTitle(provider) {
  switch (provider) {
    case 'facebook':
      return 'Facebook';

    case 'linkedin':
      return 'LinkedIn';

    case 'twitter':
      return 'Twitter';

    default:
      return absurd(provider);
  }
};

var getSocialProvider = function getSocialProvider(profile, provider) {
  return pipe(profile.socialAccounts, A.findFirst(function (social) {
    return social.__typename.toLowerCase() === provider;
  }), O.toNullable);
};

var connected = function connected(profile, provider) {
  var _getSocialProvider;

  return (_getSocialProvider = getSocialProvider(profile, provider)) === null || _getSocialProvider === void 0 ? void 0 : _getSocialProvider.connected;
};

var connect = function connect(profile, provider, challengeId) {
  var social = getSocialProvider(profile, provider);
  if (social && challengeId) window.location.href = connectUrl(social.authUrl, challengeId, window.location.host);
};

var hasError = function hasError(errors, target) {
  return errors.errors.some(function (e) {
    return e.__typename === target;
  });
};

var shareLinkReducer = function shareLinkReducer(state, action) {
  switch (action.type) {
    case 'share':
      return _objectSpread(_objectSpread({}, state), {}, {
        shared: true,
        alreadySharedIn: [].concat(_toConsumableArray(state.alreadySharedIn), [action.provider.toLowerCase()])
      });

    case 'message':
      return _objectSpread(_objectSpread({}, state), {}, {
        message: action.message
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error
      });

    case 'changeStage':
      return _objectSpread(_objectSpread({}, state), {}, {
        shared: action.providers.length > 0,
        alreadySharedIn: action.providers,
        networks: action.networks,
        message: action.message,
        error: false
      });

    default:
      return state;
  }
};

var CardImage = styled('img', {
  shouldForwardProp: isPropValid
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 288px;\n  object-fit: cover;\n  min-width: 192px;\n  width: ", ";\n"])), function (p) {
  return p.isMobile ? '100%' : p.isTablet ? '384px' : '395px';
});

var SocialShare = function SocialShare(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      profile = _ref.profile,
      completeStageStatus = _ref.completeStageStatus,
      _ref$isPreview = _ref.isPreview,
      isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
      prospect = _ref.prospect;
  var previewDescription = stage.previewDescription,
      previewImageUrl = stage.previewImageUrl,
      previewTitle = stage.previewTitle,
      defaultText = stage.defaultText,
      facebook = stage.facebook,
      twitter = stage.twitter,
      linkedin = stage.linkedin,
      sharedIn = stage.sharedIn,
      minimumCharacters = stage.minimumCharacters;
  var url = stage.__typename === 'ShareLinkStage' ? stage.shareURL : stage.url;

  var _useChallengePlayer = useChallengePlayer(),
      challengePlayerState = _useChallengePlayer.challengePlayerState;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useReducer = useReducer(shareLinkReducer, {
    shared: sharedIn.length > 0,
    message: defaultText || '',
    networks: {
      facebook: facebook,
      twitter: twitter,
      linkedin: linkedin
    },
    alreadySharedIn: sharedIn,
    error: false
  }),
      _useReducer$ = _useReducer[0],
      shared = _useReducer$.shared,
      message = _useReducer$.message,
      networks = _useReducer$.networks,
      alreadySharedIn = _useReducer$.alreadySharedIn,
      error = _useReducer$.error,
      dispatch = _useReducer[1];

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var isTablet = useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  });

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useState = useState('facebook'),
      currentProvider = _useState[0],
      setCurrentProvider = _useState[1];

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isShareModalOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      openShareModal = _useToggle2$.on,
      closeShareModal = _useToggle2$.off;

  var _useToggle3 = useToggle(),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      captionError = _useToggle4[0],
      _useToggle4$ = _useToggle4[1],
      setCaptionError = _useToggle4$.on,
      removeCaptionError = _useToggle4$.off;

  useEffect(function () {
    dispatch({
      type: 'changeStage',
      providers: sharedIn,
      networks: {
        facebook: facebook,
        twitter: twitter,
        linkedin: linkedin
      },
      message: defaultText || ''
    });
  }, [stage.id, sharedIn, facebook, twitter, linkedin, defaultText]);
  var connectAccount = useCallback(function (provider) {
    var _challengePlayerState;

    connect(profile, provider, (_challengePlayerState = challengePlayerState.challengeConfig) === null || _challengePlayerState === void 0 ? void 0 : _challengePlayerState.uuid);
  }, [profile, stage]);

  var _useShareContent = useShareContent({
    onCompleted: E.match(function (error) {
      console.error(error);
      showAlert(alerts.error(t));
    }, function (_ref2) {
      var shareContent = _ref2.shareContent;

      if (shareContent.__typename === 'ShareContentErrors') {
        if (hasError(shareContent, 'AuthExpiredError')) {
          showAlert(alerts.authExpiredError(providerTitle(currentProvider), function () {
            return connectAccount(currentProvider);
          }, t));
        } else if (hasError(shareContent, 'NotConnectedError')) {
          showAlert(alerts.unconnectedError(providerTitle(currentProvider), function () {
            return connectAccount(currentProvider);
          }, t));
        } else {
          showAlert(alerts.error(t));
        }
      } else {
        showAlert(alerts.success(shareContent.message, t));
        dispatch({
          type: 'share',
          provider: currentProvider
        });
        closeShareModal();
      }
    })
  }),
      _useShareContent2 = _slicedToArray(_useShareContent, 2),
      shareContent = _useShareContent2[0],
      mutationStatus = _useShareContent2[1];

  var triggerShare = useCallback(function (provider, message) {
    if (isPreview) return;
    setCurrentProvider(provider);
    void shareContent({
      variables: {
        input: {
          id: stage.id,
          message: message,
          provider: provider,
          linkInfo: {
            image: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : '',
            imageUrl: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : '',
            url: url !== null && url !== void 0 ? url : '',
            originalUrl: url !== null && url !== void 0 ? url : '',
            title: previewTitle !== null && previewTitle !== void 0 ? previewTitle : '',
            description: previewDescription !== null && previewDescription !== void 0 ? previewDescription : ''
          }
        }
      }
    });
  }, [stage, previewDescription, previewImageUrl, previewTitle, url, shareContent, isPreview]);
  var sharing = DE.isPending(mutationStatus) || DE.isRefresh(mutationStatus);

  var checkCount = function checkCount() {
    if (minimumCharacters && message.length < minimumCharacters) {
      setCaptionError();
      return false;
    } else {
      removeCaptionError();
      return true;
    }
  };

  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref3) {
    var completeStage = _ref3.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsxs(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex'
      },
      children: [/*#__PURE__*/_jsx(ShareButton, {
        points: stage.points,
        networks: networks,
        alreadySharedIn: alreadySharedIn,
        isLoading: sharing,
        checkCount: checkCount,
        onShare: function onShare(provider) {
          setCurrentProvider(provider);

          if (provider === 'facebook' && !isPreview) {
            if (isMobileBrowser()) return;
            var hashtagRegexp = /(?:^|\s)#[a-zA-Z0-9!@#%$&()\\-`.+,"]+/g;
            var emojiFreeMessage = stripEmojis(message !== null && message !== void 0 ? message : '');
            var hashtags = message.match(hashtagRegexp);
            var quote = emojiFreeMessage.replace(hashtagRegexp, '').trim();
            if (copyToClipboard(quote)) showAlert(alerts.textCopied(t));
            var payload = {
              method: 'share',
              display: 'popup',
              href: url !== null && url !== void 0 ? url : '',
              media: !url && previewImageUrl ? [previewImageUrl] : null,
              hashtag: hashtags ? hashtags[0] : undefined
            };
            window.FB.ui(payload, function (response) {
              // this will check if there is at least a response ('' or [] considered as success) and if there is no error_message
              if (response !== null && typeof response !== 'undefined' && !response.error_message) // Github Copilot
                void triggerShare('facebook', message);
            });
            return;
          }

          isPreview || connected(profile, provider) ? openShareModal() : !isPreview && connectAccount(provider);
        }
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: shared ? '' : t('You must first share the post to at least 1 social account'),
        arrow: true,
        disableFocusListener: true,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(AsyncButton, {
            status: mutationValue,
            text: ['Submitting...', 'Saved', stage.completionText || 'Next', stage.completionText || 'Next'],
            variant: shared ? 'contained' : 'text',
            onClick: function onClick() {
              return completeStage({
                shareLinkInput: {
                  stageID: stage.id,
                  activityID: activity === null || activity === void 0 ? void 0 : activity.id
                }
              });
            },
            disabled: !shared
          })
        })
      })]
    }),
    "data-element": "StageLayout",
    "data-component": "SocialShare",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h4",
      sx: {
        mb: 1
      },
      "data-element": "Typography",
      "data-component": "SocialShare",
      "data-source-file": "index.tsx",
      children: t('Edit your caption')
    }), /*#__PURE__*/_jsx(TextField, {
      multiline: true,
      value: message,
      error: error || captionError,
      helperText: minimumCharacters ? t('{{messageLength}}/{{minimumCharacters}} required character(s)', {
        messageLength: message.length,
        minimumCharacters: minimumCharacters
      }) : t('{{messageLength}} character(s)', {
        messageLength: message.length
      }),
      variant: "outlined",
      size: "small",
      sx: {
        width: 1
      },
      onChange: function onChange(event) {
        dispatch({
          type: 'message',
          message: event.target.value
        });
        if (minimumCharacters && captionError && event.target.value.length >= minimumCharacters) removeCaptionError();
      },
      "data-element": "TextField",
      "data-source-file": "index.tsx"
    }), url ? /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        mt: 3
      },
      children: /*#__PURE__*/_jsx(LinkCard, {
        previewDescription: previewDescription !== null && previewDescription !== void 0 ? previewDescription : '',
        previewImageUrl: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : '',
        previewTitle: previewTitle !== null && previewTitle !== void 0 ? previewTitle : '',
        url: url
      })
    }) : previewImageUrl ? /*#__PURE__*/_jsxs(Box, {
      sx: {
        mt: 3,
        width: 1,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      },
      children: [/*#__PURE__*/_jsx(Link, {
        href: previewImageUrl,
        sx: {
          textDecoration: 'none'
        },
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/_jsx(CardImage, {
          src: previewImageUrl,
          alt: previewTitle !== null && previewTitle !== void 0 ? previewTitle : '',
          isMobile: isMobile,
          isTablet: isTablet
        })
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        children: t('Image will be shared on your post')
      })]
    }) : null, /*#__PURE__*/_jsx(FacebookScripts, {
      "data-element": "FacebookScripts",
      "data-source-file": "index.tsx"
    }), isShareModalOpen && /*#__PURE__*/_jsx(ShareModal, {
      message: message,
      previewDescription: previewDescription,
      previewImageUrl: previewImageUrl,
      previewTitle: previewTitle,
      minimumCharacters: minimumCharacters,
      url: url,
      onClose: closeShareModal,
      provider: currentProvider,
      onShare: function onShare(provider) {
        return function (message) {
          return triggerShare(provider, message);
        };
      },
      sharing: sharing
    })]
  });
};

export default SocialShare;